export function trimString(value) {
  try {
    return value.trim();
  }
  catch(e) {
    return value;
  }
}
